function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t.return || t.return(); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import echartsNew from '@/components/echartsNew/index';
import { businessData } from '@/api/dashboard';
import { checkPermi } from '@/utils/permission'; // 权限判断函数

// 经营数据 key → data 字段映射
var STAT_KEY_MAP = {
  '在售商品': 'onSaleProductNum',
  '待审核商品': 'awaitAuditProductNum',
  '待发货': 'notShippingOrderNum',
  '待使用': 'awaitVerificationOrderNum',
  '待退款': 'refundingOrderNum'
};
export default {
  components: {
    echartsNew: echartsNew
  },
  data: function data() {
    return {
      grid: {
        xl: 3,
        lg: 3,
        md: 6,
        sm: 8,
        xs: 8
      },
      nav_list: [{
        bgColor: '#E8B500',
        icon: 'icon-youhuiquan',
        title: '优惠券',
        url: '/coupon/list',
        perms: ['merchant:coupon:page:list']
      }, {
        bgColor: '#4BCAD5',
        icon: 'icon-shangpinguanli',
        title: '商品管理',
        url: '/product/list',
        perms: ['merchant:product:page:list']
      }, {
        bgColor: '#A277FF',
        icon: 'icon-a-dingdanguanli1',
        title: '订单管理',
        url: '/order/list',
        perms: ['merchant:order:page:list']
      }, {
        bgColor: '#1890FF',
        icon: 'icon-xitongshezhi',
        title: '系统设置',
        url: '/operation/modifyStoreInfo',
        perms: ['merchant:base:info']
      }, {
        bgColor: '#EF9C20',
        icon: 'icon-caiwuguanli',
        title: '财务管理',
        url: '/finance/capitalFlow',
        perms: ['merchant:finance:page:capitalFlow']
      }],
      statisticData: [{
        title: '在售商品',
        num: 0,
        path: '/product/list',
        perms: ['merchant:product:page:list']
      }, {
        title: '待审核商品',
        num: 0,
        path: '/product/list',
        perms: ['merchant:product:page:list']
      }, {
        title: '待发货',
        num: 0,
        path: '/order/list',
        perms: ['merchant:order:page:list']
      }, {
        title: '待使用',
        num: 0,
        path: '/order/list',
        perms: ['merchant:order:page:list']
      }, {
        title: '待退款',
        num: 0,
        path: '/order/refund',
        perms: ['merchant:order:page:refund']
      }],
      optionData: {},
      applyNum: 0,
      style: {
        height: '250px'
      }
    };
  },
  computed: {
    /** 快捷入口：菜单 + 权限 双重过滤 */permList: function permList() {
      var _this = this;
      return this.nav_list.filter(function (item) {
        return _this.hasMenuItem(item.url) && checkPermi(item.perms);
      });
    },
    /** 经营数据：菜单 + 权限 双重过滤 */businessList: function businessList() {
      var _this2 = this;
      return this.statisticData.filter(function (item) {
        return _this2.hasMenuItem(item.path) && checkPermi(item.perms);
      });
    }
  },
  mounted: function mounted() {
    if (checkPermi(['merchant:statistics:home:operating:data'])) this.getbusinessData();
  },
  methods: {
    checkPermi: checkPermi,
    /** 检查 path 是否在用户菜单列表中 */hasMenuItem: function hasMenuItem(path) {
      var menuList = this.$store.state.user.menuList || [];
      if (!menuList.length) return false;
      var _findPath = function findPath(list, target) {
        var _iterator = _createForOfIteratorHelper(list),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var item = _step.value;
            if (item.path === target) return true;
            if (item.children && item.children.length && _findPath(item.children, target)) return true;
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        return false;
      };
      return _findPath(menuList, path);
    },
    navigatorTo: function navigatorTo(path) {
      this.$router.push(path);
    },
    getbusinessData: function getbusinessData() {
      var _this3 = this;
      businessData().then(function (res) {
        // 按 title 匹配赋值，解决过滤后索引错位问题
        _this3.statisticData.forEach(function (item) {
          var key = STAT_KEY_MAP[item.title];
          if (key && res[key] != null) {
            item.num = res[key];
          }
        });
      });
    }
  }
};